import { render, staticRenderFns } from "./idCard.vue?vue&type=template&id=02d9b8d3&"
import script from "./idCard.vue?vue&type=script&lang=js&"
export * from "./idCard.vue?vue&type=script&lang=js&"
import style0 from "./idCard.vue?vue&type=style&index=0&id=02d9b8d3&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports